<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      中创
      <small>/账户管理</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-left:0px;padding-right:0px;padding-top: 0px"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">账户管理</h4>
              </div>
              <!-- end panel-heading -->
              <form style="padding-top:25px;">
                <fieldset>
                  <div class="form-group row m-b-15" style="position:relative">
                    <label class="col-md-1 col-form-label">品牌名称</label>
                    <div class="col-md-3">
                     <input type="text" class="form-control">
                    </div>
                    <label class="col-md-1 col-form-label">状态</label>
                    <div class="col-md-2">
                     <select class="form-control" >
											<option value="1" style="display:none">请输入状态</option>
                      <option value="2">正常</option>
                      <option value="3">已删除</option>
										</select>
                    </div>
                    <div class="col-md-1">
                      <button type="submit" class="btn btn-primary m-r-5">筛选</button>
                    </div>
                     <div class="form-group row m-b-15"></div> 
                    <div style="position:absolute;right:36px"> 
                <button type="submit" class="btn btn-primary m-r-5">新增品牌</button>
                <button type="submit" class="btn btn-primary m-r-5">导出</button>
                </div>
                  </div>
                  
                </fieldset>
              </form>
            
              <!-- begin panel-body -->
              <div class="panel-body">
                <el-table :data="StoreGoodsList" border style="width: 100%">
                  <el-table-column prop="id" label="ID"  align="center"></el-table-column>
                  <el-table-column prop="name" label="品牌名称"  align="center"></el-table-column>
                  <el-table-column prop="pzncode" label="录入时间"  align="center"></el-table-column>
                  <el-table-column prop="code" label="状态"  align="center"></el-table-column>
                  <el-table-column label="操作" width="180">
                    <template></template>
                  </el-table-column>
                </el-table>
                <div style="float:right;margin-top:8px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="1"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandManagement",
  data() {
    return {
      currentPage: 1,
      StoreGoodsList: [],
      value2: "",
      BrandNameValue: ""
    };
  },
  mounted: function() {
    
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountManage/AccounList.vue